import { environment } from 'src/environments/environment';

interface IConsole {
    logObject: any;
    logString: any;
    warn: any;
    throwManualExcluded: any;
    warnProcedure: any;
    error: any;
}

export type Logging = 'none' | 'develop' | 'production';

const columnWidth = 30;
const methodName = '';

function padString(args: any[]): string {
    args = args.map(item => typeof(item) === 'object' ? JSON.stringify(item) : item);
    if (args.length > 1) {
        args[0] = args[0].padEnd(columnWidth, ' ') + '=> ';
    }

    return args.join('');
}

function logObject(...args: any[]) {
    if (args.length == 1) {
        console.log(args[0]);
    } else if (args.length == 2) {
        args[0] = args[0].padEnd(columnWidth, ' ') + '=> ';
        console.log(args[0], '\n', args.slice(1));
    } else if (args.length > 2) {
        args[0] = args[0].padEnd(columnWidth, ' ') + '=> ';
        console.log(args[0], args[1], '\n', args.slice(2));
    };
}
function logString(...args: any[]) {return console.log(padString(args));}
function warn(...args: any[]) {return console.warn('%c' + padString(args), 'color: #FF8C00');}
function warnProcedure(...args: any[]) {return console.error('%c' + [...args, 'WARN', 'PROCEDURE'].join('--') + '--', 'color: #FF8C00');}
function error(...args: any[]) {return console.error('%c' + padString(args), 'color: #DC143C');}
function throwManualExcluded(...args: any[]) {throw new Error('--' + [...args, 'MANUAL', 'EXCLUDED'].join('--') + '--')}

export class LogService {
    static logging: Logging[] = ['develop', 'production'];

    console: IConsole;

    constructor(
        private logType: Logging
    ) {
        const productionLog = !this.isDevLogging() && logType === 'production';
        const developLog = this.isDevLogging() && this.isLogType();
        this.console = developLog || productionLog
            ? LogService.ActiveLogging()
            : LogService.NoLogging();
    }

    private isDevLogging(): boolean {
        return !environment.production;
    }

    private isLogType(): boolean {
        return LogService.logging.some(item => item === this.logType);
    }

    private static ActiveLogging(): IConsole {
        return {
            logObject: logObject,
            logString: logString,
            warn: warn,
            warnProcedure: warnProcedure,
            throwManualExcluded: throwManualExcluded,
            error: error
        };
    }

    private static NoLogging(): IConsole {
        const NO_OPERATION = () => {};
        return {
            logObject: NO_OPERATION,
            logString: NO_OPERATION,
            warn: NO_OPERATION,
            warnProcedure: NO_OPERATION,
            throwManualExcluded: NO_OPERATION,
            error: NO_OPERATION
        };
    }

    static envDev = new LogService('develop').console;
    static prodDev = new LogService('production').console;
}
